/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

export default {
  hover: {
    export: {
      source: '.highcharts-container .highcharts-exporting-group',
      popup: {
        position: {
          origin: 'left'
        },
        disable: {
          option: 'exporting.enabled'
        }
      }
    },
    legend: {
      source: '.highcharts-container .highcharts-legend',
      popup: {
        position: {
          origin: 'bottom',
          offset: {
            top: -10,
            left: 0
          }
        },
        disable: {
          option: 'legend.enabled'
        }
      }
    },
    'legend-series': {
      isArray: true,
      parent: 'div.highcharts-legend',
      source: '.highcharts-container .highcharts-legend-item text',
      copy: '.highcharts-container div.highcharts-legend-item',
      preProps: 'legend--useHTML',
      popup: {
        position: {
          origin: 'bottom'
        }
      }
    },
    'legend-series-2': {
      isArray: true,
      parent: 'div.highcharts-legend',
      source: '.highcharts-container div.highcharts-legend-item',
      copy: '.highcharts-container div.highcharts-legend-item',
      popup: {
        position: {
          origin: 'bottom'
        }
      }
    }
  }
};
